'use client';

import { alertHandler } from '../../utils/alertHandler';
import { Alert } from '../Alert';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import styles from './AlertService.module.scss';
import { IconExit } from '@/public/assets/icons/IconExit';

export function AlertService() {
  const [alerts, setAlerts] = useState(alertHandler.getAlerts());

  function handleDeleteAlert(id: string) {
    alertHandler.removeAlertById(id);
  }

  useEffect(() => {
    const updateAlerts = () => setAlerts([...alertHandler.getAlerts()]);
    alertHandler.subscribe(updateAlerts);
    return () => {
      alertHandler.unsubscribe(updateAlerts);
    };
  }, []);

  return (
    <div className={styles.alerts}>
      {alerts.map((item) => (
        <Alert
          key={item.id}
          status={item.status}
          title={item.message || item.defaultText}
          action={
            <IconButton onClick={() => handleDeleteAlert(item.id)}>
              <IconExit fill="var(--sapphire-20)"/>
            </IconButton>
          }
        >
          {item.subTitle}
        </Alert>
      ))}
    </div>
  );
}
